import type { BeamerParameters, OnNotificationsCountChangedCallback } from './config';
import { config } from './config';

declare global {
  // eslint-disable-next-line no-var, vars-on-top
  var Beamer:
    | {
        update: (obj: Record<string, unknown>) => void;
        destroy: () => void;
        show: () => void;
      }
    | undefined;
  // eslint-disable-next-line no-var, vars-on-top, camelcase
  var beamer_config: Partial<BeamerParameters> | undefined;
}

export const setupBeamerConfig = (
  language: string,
  onNotificationsCountChangedCallback?: OnNotificationsCountChangedCallback,
): void => {
  global.beamer_config = {
    ...config,
    language,
    callback: onNotificationsCountChangedCallback,
  };
};

const isTestEnv = (): boolean => global.getBasedOnEnvironment({ test: true, default: false });

export const isInitialised = (): boolean => !!global.Beamer;

export const init = (callback: () => void): void => {
  if (isTestEnv() || isInitialised()) return;

  const node = document.createElement('script');
  const head = document.getElementsByTagName('head')[0];
  node.defer = true;
  node.src = 'https://app.getbeamer.com/js/beamer-embed.js';
  node.onload = () => callback();
  head.appendChild(node);
};

export const destroy = (): void => {
  global.Beamer?.destroy();
};

export const show = (): void => global.Beamer?.show();

export const updateUserId = (id: number): void => global.Beamer?.update({ user_id: id.toString() });
